import { useLoggerParams } from '../init/useLoggerParams';

/**
 * Loads the default "latest" range by clearing URL params.
 * useInitializeStream then computes the default range (last hour) and syncs to store.
 */
export function useLoadLatestRange() {
  const [, setLoggerParams] = useLoggerParams();

  return () => {
    setLoggerParams({ from: null, to: null, cursor: null });
  };
}
